import { render } from "./modal-lg.vue?vue&type=template&id=2e095f9c&scoped=true"
import script from "./modal-lg.vue?vue&type=script&lang=js"
export * from "./modal-lg.vue?vue&type=script&lang=js"

import "./modal-lg.vue?vue&type=style&index=0&id=2e095f9c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e095f9c"]])

export default __exports__